import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Javier M.',
    age: 34,
    location: 'Buenos Aires',
    text: 'Venía con dolores de codo crónicos. Apliqué el protocolo del Tomo 13 y en 3 semanas volví a jugar sin molestias. Además, la táctica para dominar el medio me cambió la forma de ver los partidos.',
    rating: 5
  }, {
    name: 'Pablo R.',
    age: 41,
    location: 'Córdoba',
    text: 'Soy zurdo y siempre sentí que no aprovechaba mi ventaja. El bloque 2 es una locura. Ahora sé exactamente dónde pararme y cómo incomodar al rival. El mejor material que leí de pádel.',
    rating: 5
  }, {
    name: 'Diego S.',
    age: 29,
    location: 'Rosario',
    text: 'Me estancaba en los 3ros sets, me quedaba sin piernas. El plan de 90 días y la calculadora de hidratación hicieron que llegue al final del partido entero. Totalmente recomendado.',
    rating: 5
  }, {
    name: 'Martín L.',
    age: 38,
    location: 'Mendoza',
    text: 'Dejé de adivinar qué hacer en la cancha. Los patrones de juego del Tomo 3 son clarísimos. Pasé de perder en primera ronda a llegar a semis en mi categoría.',
    rating: 5
  }, {
    name: 'Federico G.',
    age: 45,
    location: 'CABA',
    text: 'El manual anti-rivales vale cada centavo. Jugamos contra unos pibes que le pegaban a todo y supimos cómo enfriarles el partido. Excelente inversión para cualquier amateur que quiera mejorar en serio.',
    rating: 5
  }];
  return <div className="my-16" data-id="element-137">
      <h2 className="text-3xl font-display text-center mb-10 uppercase tracking-wide" data-id="element-138">
        Lo que dicen{' '}
        <span className="text-[var(--pd-green)]" data-id="element-139">nuestros jugadores</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
        {testimonials.map((test, index) => <div key={index} className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[var(--pd-green)]/50 transition-colors" data-id="element-141">
            <div className="flex text-[var(--pd-green)] mb-4" data-id="element-142">
              {[...Array(test.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-143" />)}
            </div>
            <p className="text-zinc-300 italic mb-6 text-sm leading-relaxed" data-id="element-144">
              "{test.text}"
            </p>
            <div className="flex items-center gap-3 border-t border-zinc-800 pt-4" data-id="element-145">
              <div className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center font-bold text-[var(--pd-green)]" data-id="element-146">
                {test.name.charAt(0)}
              </div>
              <div data-id="element-147">
                <p className="font-bold text-white text-sm" data-id="element-148">{test.name}</p>
                <p className="text-xs text-zinc-500" data-id="element-149">
                  {test.age} años | {test.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}